/* eslint-disable react/display-name */
import CellData from 'modules/_shared/components/Tables/CellData';
import SocietyGuestsAccessBadge from 'modules/society/components/SocietyGuests/components/SocietyGuestsAccessBadge';

function tableColumns(i18n) {
  return [
    {
      name: i18n.t('Society'),
      field: 'societyName',
      selector: (row) => row[i18n.t('Society')],
      sortable: true,
      grow: 2,
      cell: (row) =>
        CellData.Society({
          society: row.society,
          url: '/consejos',
          type: 'light',
          showHolding: false,
          customLink: row.link || '',
          noRedirect: row.noRedirect,
        }),
      export: true,
    },
    {
      name: i18n.t('Total de Consejos'),
      field: 'councilsTotal',
      selector: (row) => row[i18n.t('CouncilsTotal')],
      sortable: true,
      grow: 1,
      cell: (row) => row[i18n.t('CouncilsTotal')],
      export: true,
    },
  ];
}
export default tableColumns;
